import styled from 'styled-components/native'

export const StyledInputContainer = styled.View<{ hide?: boolean }>`
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
  gap: 4px;
  display: ${({ hide }) => (hide ? 'none' : 'flex')};
`
